module.exports = __webpack_public_path__ + "img/CYP-Case-Study-600px.bb2735ec.jpeg";